import React, { useEffect } from 'react'
import {
  Box,
  Button,
  Grid,
  Stack,
  Theme,
  Typography,
  useMediaQuery
} from '@mui/material'
import {
  HeaderNavbarAvatarLink,
  HeaderNavbarAvatarWrapper,
  HeaderNavbarRoot
} from './styles'
import { useDashboard } from 'store/DashboardContext'
import { FileBox, Menu, X, House } from 'lucide-react'
import { SITE_LOGO } from 'variables/constants'
import { AccountMenu } from './components/AccountMenu/AccountMenu'
import useAuthStore from 'store/userStore'
import { Link, NavLink, useHistory } from 'react-router-dom'
import { SelectQBank } from './components/SelectQBank'
import { ButtonWithIcon } from 'components/Buttons/ButtonWithIcon'

export const HeaderNavbar: React.FC = () => {
  const {
    state: { isSideNavOpen },
    actions: { toggleSideNav }
  } = useDashboard()
  const history = useHistory()
  const { user } = useAuthStore()

  // Make sure all hooks are called before any early returns
  const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))

  useEffect(() => {
    if (mobile && !isSideNavOpen) {
      toggleSideNav()
    }
  }, [])

  if (!user) return null // Only return early after hooks are called

  const userLogo = (() => {
    if (user.given_name && user.family_name) {
      return user.given_name[0] + user.family_name[0]
    }
    if (user.given_name || user.family_name) {
      return user.given_name ? user.given_name[0] : user.family_name[0]
    }
    return 'AI'
  })()

  return (
    <HeaderNavbarRoot
      sx={(theme) => ({
        borderBottom: `${theme.spacing(2)} solid ${
          !isSideNavOpen && mobile
            ? theme.palette.white.main
            : theme.palette.background.default
        }`,
        [theme.breakpoints.down('md')]: {
          borderBottom: `${theme.spacing(1)} solid ${
            !isSideNavOpen && mobile
              ? theme.palette.white.main
              : theme.palette.background.default
          }`
        }
      })}
    >
      <Grid container xxxs={12} spacing={1} alignItems={'center'}>
        <Grid item xxxs={3}>
          {!mobile ? (
            <Box display={'flex'} justifyContent={'flex-start'}>
              <Box minWidth={'54px'}>
                <Button
                  sx={{
                    padding: 0,
                    minWidth: 0
                  }}
                  onClick={() => toggleSideNav()}
                >
                  <Menu />
                </Button>
              </Box>
              <HeaderNavbarAvatarWrapper>
                <HeaderNavbarAvatarLink to="/">
                  <Typography variant="h6" fontWeight={'bold'}>
                    {SITE_LOGO}
                  </Typography>
                </HeaderNavbarAvatarLink>
              </HeaderNavbarAvatarWrapper>
            </Box>
          ) : (
            <Box>
              <Button
                sx={{
                  padding: 0,
                  minWidth: 0
                }}
                onClick={() => {
                  console.log('toggleSideNav', isSideNavOpen)
                  toggleSideNav()
                }}
              >
                {!isSideNavOpen ? <X /> : <Menu />}
              </Button>
            </Box>
          )}
        </Grid>
        <Grid item xxxs={6} display={'flex'} justifyContent={'center'}>
          {!mobile && <SelectQBank qbanks={qbanks} />}
          {mobile && (
            <Box>
              <Link
                to="/"
                style={{
                  textDecoration: 'none'
                }}
              >
                <Typography variant="h6" fontWeight={'bold'}>
                  {SITE_LOGO}
                </Typography>
              </Link>
            </Box>
          )}
        </Grid>
        <Grid
          item
          xxxs={3}
          display={'flex'}
          justifyContent={'flex-end'}
          alignItems={'center'}
        >
          <Stack flexDirection={'row'}>
            <Box>
              <ButtonWithIcon tooltipText={'Creator Mode'} color="info">
                <FileBox />
              </ButtonWithIcon>
            </Box>
            <Box>
              <ButtonWithIcon
                tooltipText={'Home Dashboard'}
                color="primary"
                onClick={() => {
                  history.push('/dashboard/home')
                }}
              >
                <House />
              </ButtonWithIcon>
            </Box>
          </Stack>
          <AccountMenu avatar={userLogo} />
        </Grid>
      </Grid>
    </HeaderNavbarRoot>
  )
}

const qbanks = [
  {
    qbank_id: '1',
    name: 'absitedemo'
  },
  {
    qbank_id: '2',
    name: 'absite'
  }
]
